import { Grid, Typography } from "@mui/joy";
import React from "react";
import BuildingList, { Building } from "./BuildingList";
import BuildingPage from "./BuildingPage";
import { useParams } from "react-router-dom";
import { Util } from "../Helpers/Util";

interface BuildingPortalProps {}

// localStorage key for persisting selected building
const BUILDING_STORAGE_KEY = "selectedBuildingId";

export default function BuildingPortal(props: BuildingPortalProps) {
	const [selected, setSelected] = React.useState(null as any as Building);
	const [hideList, setHideList] = React.useState(false);
	const u = useParams()["*"];

	// Get the default building ID - URL param takes priority, then localStorage
	const getDefaultBuildingId = (): string | undefined => {
		if (u) return u;
		return localStorage.getItem(BUILDING_STORAGE_KEY) || undefined;
	};

	const selectBuilding = (b: Building) => {
		setSelected(b);
		// Persist selected building to localStorage
		if (b?.ID) {
			localStorage.setItem(BUILDING_STORAGE_KEY, b.ID);
		}
	};

	return (
		<Grid columnSpacing={1} container sx={{ overflowY: "hidden" }}>
			<Grid xs={hideList ? 0 : 2} sx={{ overflowY: "auto", height: "100%" }}>
				<BuildingList hide={() => setHideList(true)} selectBuilding={selectBuilding} defaultBuilding={getDefaultBuildingId()} />
			</Grid>
			<Grid xs={hideList ? 12 : 10} sx={{ overflowY: "hidden", height: "100%", display: "flex", flexDirection: "column" }}>
				{selected && <BuildingPage BuildingID={selected.ID} />}
			</Grid>
		</Grid>
	);
}
